/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Table_IndexInputs */

const en_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const fr_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const de_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const it_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const ru_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const es_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const zh_cn2_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const ja_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const hi_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const pt_pt2_tags_manager_table_index = /** @type {(inputs: Tags_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

/**
* | output |
* | --- |
* | "#" |
*
* @param {Tags_Manager_Table_IndexInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_table_index = /** @type {((inputs?: Tags_Manager_Table_IndexInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Table_IndexInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_table_index(inputs)
	if (locale === "de") return de_tags_manager_table_index(inputs)
	if (locale === "it") return it_tags_manager_table_index(inputs)
	if (locale === "ru") return ru_tags_manager_table_index(inputs)
	if (locale === "es") return es_tags_manager_table_index(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_table_index(inputs)
	if (locale === "ja") return ja_tags_manager_table_index(inputs)
	if (locale === "hi") return hi_tags_manager_table_index(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_table_index(inputs)
	return en_tags_manager_table_index(inputs)
});